import { useState, useCallback } from 'react';

// Utility functions for date validation
export const getCurrentDateTime = () => {
  const now = new Date();
  return now.toISOString().slice(0, 16);
};

export const getTodayDate = () => {
  const today = new Date();
  return today.toISOString().slice(0, 10);
};

export const getNextDay = (dateString) => {
  const date = new Date(dateString);
  date.setDate(date.getDate() + 1);
  return date.toISOString().slice(0, 10);
};

export const useFormValidation = (formData) => {
  const [validationErrors, setValidationErrors] = useState({});

  const validateField = useCallback((name, value) => {
    let error = '';
    const today = getTodayDate();
    const now = getCurrentDateTime();

    switch (name) {
      case 'scheduledDatetime':
        if (value && value < now) {
          error = 'Surgery cannot be scheduled in the past';
        }
        break;

      case 'lastDose':
        if (value && value > now) {
          error = 'Last dose cannot be in the future';
        }
        break;

      case 'stopDate':
        if (value) {
          if (value < today) {
            error = 'Stop date cannot be in the past';
          }
          if (formData.scheduledDatetime) {
            const surgeryDate = formData.scheduledDatetime.slice(0, 10);
            if (value > surgeryDate) {
              error = 'Stop date should be before or on surgery date';
            }
          }
        }
        break;

      case 'age':
        const ageNum = parseInt(value);
        if (value && (ageNum < 0 || ageNum > 150)) {
          error = 'Please enter a valid age between 0-150';
        }
        break;

      case 'guardianContact':
        if (value && value.length < 10) {
          error = 'Please enter a valid phone number';
        }
        break;

      case 'estimatedBloodLoss':
        const bloodLoss = parseInt(value);
        if (value && (bloodLoss < 0 || bloodLoss > 10000)) {
          error = 'Please enter a realistic blood loss estimate (0-10000ml)';
        }
        break;

      default:
        break;
    }

    setValidationErrors(prev => ({
      ...prev,
      [name]: error
    }));

    return error === '';
  }, [formData.scheduledDatetime]);

  const validateForm = useCallback(() => {
    const errors = {};
    const requiredFields = [
      'uhid', 'ipNumber', 'name', 'age', 'sex', 'room',
      'diagnosis', 'proposedSurgery', 'surgeonName'
    ];

    requiredFields.forEach(field => {
      if (!formData[field] || formData[field] === '') {
        errors[field] = 'This field is required';
      }
    });

    // Validate scheduled datetime
    if (formData.scheduledDatetime && formData.scheduledDatetime < getCurrentDateTime()) {
      errors.scheduledDatetime = 'Surgery cannot be scheduled in the past';
    }

    // Validate age
    const age = parseInt(formData.age);
    if (formData.age && (age < 0 || age > 150)) {
      errors.age = 'Please enter a valid age between 0-150';
    }

    // Validate if minor needs guardian info
    if (age < 18 && (!formData.guardianName || !formData.guardianContact)) {
      if (!formData.guardianName) errors.guardianName = 'Guardian name required for minors';
      if (!formData.guardianContact) errors.guardianContact = 'Guardian contact required for minors';
    }

    setValidationErrors(errors);
    return Object.keys(errors).length === 0;
  }, [formData]);

  return {
    validationErrors,
    setValidationErrors,
    validateField,
    validateForm
  };
};
